import { render } from "./KullanicilarSayfasi.vue?vue&type=template&id=e55f4528"
import script from "./KullanicilarSayfasi.vue?vue&type=script&lang=js"
export * from "./KullanicilarSayfasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__